import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-landing-page',
  imports: [RouterLink],
  templateUrl: './landing-page.html',
  styleUrl: './landing-page.scss',
})
export class LandingPage implements OnInit {
  private languageService = inject(LanguageService);
  currentLocale = signal<string>('en');

  toggleLanguage() {
    this.languageService.toggleLocale();
  }
  ngOnInit() {
    this.currentLocale.set(this.languageService.getCurrentLocale());
  }
}
